import type { I_QuickLink } from '../interfaces'
import { ListNames } from '../config/configuration'
import { rhybusRListsHttp } from '../api/rhybus-list-http'

const isArchived = (value: any) =>
  value === true || value === 1 || value === '1' || value === 'Yes' || value === 'true'

export const getQuickLinksData = async (): Promise<I_QuickLink[]> => {
  try {
    const list = await rhybusRListsHttp().getList(ListNames.QUICK_LINK)
    const items = [...(await list.query().orderBy([{ orderBy: 'Title', ascending: true }]).get<any>())]
    return (items ?? [])
      .filter((item: any) => !item.IsDeleted && !isArchived(item.IsArchived))
      .map((item: any) => ({
        ...item,
        ID: item.ID ?? item.Id ?? item._Id ?? item.eKey,
        Id: item.Id ?? item.ID ?? item._Id ?? item.eKey,
        Title: item.Title ?? '',
        URL: item.URL ?? item.Url ?? item.url ?? '',
      })) as I_QuickLink[]
  } catch (error) {
    console.error('Failed to fetch quick links:', error)
    return []
  }
}

export const quicklinksItems = await getQuickLinksData()
